//  _        _      _         _
// | |  _  _| |_  _| |__ _  _| |__ _  _
// | |_| || | | || | '_ \ || | '_ \ || |
// |____\_,_|_|\_,_|_.__/\_,_|_.__/\_,_|
//
// Copyright © Lulububu Software GmbH - All Rights Reserved
// https://lulububu.de
//
// Unauthorized copying of this file, via any medium is strictly prohibited!
// Proprietary and confidential.

import _ from 'lodash';

import LoadingLevel       from '@constants/LoadingLevel';
import { LoadingActions } from '@slices/loading';

function loadingMiddleware() {
    return ({ dispatch, getState }) => (next) => (action) => {
        const loadingLevel = _.get(action, 'payload.loadingLevel');
        const text         = _.get(action, 'payload.text');
        const state        = getState();
        const actionToUse  = _.cloneDeep(action);

        switch (loadingLevel) {
            case LoadingLevel.increase:
                if (_.isFunction(text)) {
                    actionToUse.payload.text = text(state);
                }

                dispatch(LoadingActions.increaseLevel({
                    loadingAction: actionToUse,
                }));

                break;
            case LoadingLevel.decrease:
                dispatch(LoadingActions.decreaseLevel({
                    loadingAction: action,
                }));

                break;
            default:
                break;
        }

        return next(action);
    };
}

export default loadingMiddleware;
